export default __webpack_public_path__ + "static/media/boxes.71c942e9.png";